import { useState } from "react"
import { Popup } from "semantic-ui-react"

const tooltipstyle = {
    borderRadius: 15,
    padding: '0.2rem',
    filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.1))',
  }

function WorldMap() {
    const [hoveredLocation, setHoveredLocation] = useState(true)

    // Define locations with coordinates
      const locations = [
        { id: 1, x: 58, y: 108, region: "North America (West)", suppliers: '32' },
        { id: 2, x: 210, y: 167, region: "North America (East)", suppliers: '32' },
        { id: 3, x: 256, y: 322, region: "South America", suppliers: '32' },
        { id: 4, x: 402, y: 122, region: "Europe", suppliers: '32' },
        { id: 5, x: 452, y: 275, region: "Africa", suppliers: '32' },
        { id: 6, x: 540, y: 235, region: "India", suppliers: '32' },
        { id: 7, x: 565, y: 113, region: "Asia", suppliers: '32' },
        { id: 8, x: 680, y: 340, region: "Australia", suppliers: '32' },
    ]  

    return (
        <div className="map-cordinates">
            <svg viewBox="0 0 800 450" className="w-full h-auto" aria-label="World map with location markers">
                {/* Location markers */}
                  {locations.map((location) => (
                   /*  <Popup className="location-popover" content={<div className="location-popover"><p>{`${location.suppliers} Suppliers`}</p><div>{location.region}</div></div>} position='top center' style={tooltipstyle} trigger={<g key={location.id}> */
                      <circle
                          cx={location.x}
                          cy={location.y}
                          r={hoveredLocation === location.id ? 8 : 7}
                          fill="#3366cc"
                          //  onMouseEnter={() => setHoveredLocation(location.id)}
                          //   onMouseLeave={() => setHoveredLocation(null)}
                          className="transition-all duration-200 cursor-pointer"
                      />
                    /* </g>} /> */
                ))}  
            </svg>
        </div>
    )
}

export default WorldMap